/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect } from "react";
import moment from "moment";
import forEmpty from "@/assets/Images/forEmpty.webp";
import { useGetAxios } from "@/hooks/useGetAxios";
import ResultTable from "./ResultTable";
import Image from "next/image";

function StockResults({ name }) {
    const { data, loading, fetchData } = useGetAxios();

    useEffect(() => {
        fetchData(`/resources/stock-details/declared-results/${name}`);
    }, [name]);

    return (
        <div className="mx-2 pt-6">
            {loading ? (
                <div />
            ) : JSON.stringify(data) !== "{}" ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {Object.entries(data)
                        ?.reverse()
                        ?.map(([date, stocks], i) => (
                            <div className="grid grid-cols-12 gap-2 align-center mb-4" key={i}>
                                <div className="col-start-1 col-span-2 p-2 text-xs lg:text-sm font-bold text-primary/80 bg-[#EFF6FF] rounded h-9 flex flex-row justify-center whitespace-nowrap">
                                    {moment(date, "YYYYMM").format("MMM YY")}
                                </div>
                                <div className="col-start-3 col-span-10">
                                    {stocks.map((value, i) => (
                                        <div key={i} className="border border-[#ecf6fe] rounded-2xl overflow-hidden">
                                            <ResultTable value={value} page="stock_page" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                </div>
            ) : (
                <div className="pt-10">
                    <Image src={forEmpty} alt="icon" className="mx-auto" width={300} height={300} />
                    <div className="text-center font-Inter text-[16px] landing-[28px] text-black font-semibold mt-3">
                        Nothing to show for now
                    </div>
                    <div className="text-center font-Inter text-[12px] landing-[18px] text-[#414141] mt-2">
                        Don’t worry we’l keep you posted
                    </div>
                </div>
            )}
        </div>
    );
}

export default memo(StockResults);
